import {FILE_DATA, LOADER_STATUS } from "./constants";

export const initialState = {
    loaderStatus: false,  
    fileData: [],
    
};
  
  /* eslint-disable default-case, no-param-reassign */
  const itc04AnalyticsReducer = (state = initialState, action) =>{
      switch (action.type) {
        
        case LOADER_STATUS:
          return {
            ...state,
            loaderStatus:action.loaderStatus
          }
          case FILE_DATA:
            return {
              ...state,
              fileData:action.fileData
            }
        default:
          return state;
      }
    };
  
  export default itc04AnalyticsReducer;